import { Button } from 'react-bootstrap'
import config from '../../config'

const RedirectDashboard = () => {
  const handleRedirectDashboard = () => {
    window.open(config.newBODashboard, '_blank')
  }
  return (
    <div className="text-center">
      <Button onClick={handleRedirectDashboard}>Go to New Dashboard</Button>
    </div>
  )
}

export default RedirectDashboard
